import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, Mail, Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await register(form.name, form.email, form.password);
    setLoading(false);
    if (r.ok) nav("/dashboard", { replace: true });
    else setError(r.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24">
      <div className="card p-8 w-full max-w-md glow-border" data-testid="register-card">
        <div className="eyebrow">Create account</div>
        <h1 className="text-3xl font-bold text-white mt-1">Get started</h1>
        <p className="text-[#94A3B8] text-sm mt-1">Track projects, bookings and conversations.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="relative">
            <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]"/>
            <input data-testid="register-name" required value={form.name} onChange={update("name")} className="input-field !pl-9" placeholder="Full name"/>
          </div>
          <div className="relative">
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]"/>
            <input data-testid="register-email" type="email" required value={form.email} onChange={update("email")} className="input-field !pl-9" placeholder="you@company.com"/>
          </div>
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]"/>
            <input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={update("password")} className="input-field !pl-9" placeholder="Password (min 6 chars)"/>
          </div>
          {error && <div data-testid="register-error" className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg p-3">{error}</div>}
          <button data-testid="register-submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
            {loading ? "Creating…" : (<>Create account <ArrowRight size={16}/></>)}
          </button>
        </form>

        <p className="text-sm text-[#94A3B8] mt-6">
          Already have an account? <Link to="/login" className="text-[#22D3EE] hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
